import {SwiperElementType, SwiperType} from "../molecules/SwiperTypes";

export default class AdvantageBannerAutoplayer {
  private swiperContainer: SwiperElementType;
  private interval: number | null = null;

  constructor(swiperContainer: SwiperElementType) {
    this.swiperContainer = swiperContainer;
    this.swiperContainer.addEventListener("swipertouchstart", this.touchStartListener);
    this.startInterval();
  }

  private touchStartListener = (event: CustomEvent<SwiperType[]>) => {
    this.resetInterval();
    this.startInterval();
  };

  private startInterval() {
    this.interval = window.setInterval(() => {
      this.swiperContainer.swiper.slideNext(500, false);
    }, 3000);
  }

  private resetInterval() {
    if (this.interval) {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }

  public destroy() {
    this.swiperContainer.removeEventListener("swipertouchstart", this.touchStartListener);
    this.resetInterval();
  }
}
